import { useQuery, type QueryClient } from '@tanstack/react-query';
import { get, getTodos } from '../../nucleo/api';
import { data, numero } from '../../nucleo/formato';
import type { Catalogos, Deposito } from './tipos';

/** Qualquer escrita de estoque muda saldos, valores e alertas: recarrega todas as consultas do módulo. */
export function invalidarEstoque(qc: QueryClient) {
  return qc.invalidateQueries({ predicate: (q) => String(q.queryKey[0]).startsWith('/estoque') || q.queryKey[0] === 'estoque' });
}

/** O nome padrão do inventário carrega a data ISO ("Inventário 2026-10-02"): mostra a data no formato do idioma. */
export function nomeInventario(nome: string) {
  return nome.replace(/\b\d{4}-\d{2}-\d{2}\b/g, (iso) => data(iso));
}

/** Quantidade com até 4 casas, sem zeros sobrando. */
export function qtd(v: number | null | undefined) {
  if (v === null || v === undefined) return '';
  const casas = Number.isInteger(v) ? 0 : Math.min(4, (String(v).split('.')[1] ?? '').length);
  return numero(v, casas);
}

export function useUnidades() {
  const q = useQuery({ queryKey: ['estoque', 'catalogos'], queryFn: () => get<Catalogos>('/nucleo/catalogos'), staleTime: 300_000 });
  return (q.data?.unidades ?? []).map((u) => ({ valor: u.codigo, rotulo: `${u.codigo} (${u.nome})` }));
}

export function useDepositos(enabled = true) {
  return useQuery({
    queryKey: ['estoque', 'depositos', 'opcoes'],
    queryFn: () => getTodos<Deposito>('/estoque/depositos'),
    enabled,
  });
}

/** Rótulo de produto nas buscas remotas: código e nome. */
export const rotuloProduto = (i: Record<string, unknown>) => `${String(i.codigo)} ${String(i.nome)}`;
